import React, {FunctionComponent} from 'react'
import {Navbar} from "@App/Components/Navbar";
import {Footer} from "@App/Layouts/Footer";
import {Outlet} from "react-router-dom";

export type LayoutProps = {
    embedded?: boolean
}

export const Layout: FunctionComponent<LayoutProps> = ({embedded = false}: LayoutProps) => {
    return (
        <div className="text-neutral-400 min-h-screen flex flex-col justify-between antialiased">
            {!embedded && (
                <Navbar>
                    <a href={'https://www.repareo.de'} title={'repareo.de'}>
                        <img
                            src="/images/brand/logo-light.svg"
                            className="w-24 h-auto"
                            alt=""
                        />
                    </a>
                </Navbar>
            )}
            <div className={'grow'}>
                <Outlet/>
            </div>
            {!embedded && (
                <Footer/>
            )}
        </div>
    )
}
